import { render, staticRenderFns } from "./elite_company_details.vue?vue&type=template&id=9bd67b20&scoped=true&"
import script from "./elite_company_details.vue?vue&type=script&lang=js&"
export * from "./elite_company_details.vue?vue&type=script&lang=js&"
import style0 from "./elite_company_details.vue?vue&type=style&index=0&id=9bd67b20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bd67b20",
  null
  
)

export default component.exports